import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';

import { AuthService } from './auth.service';
import { ScreenTimeTrackerService } from './services/screen-time/screen-time-tracker.service';
import { LanguageService } from './services/language.service';
import { CourseThemeService } from './services/ui/course-theme.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  title = 'gr-app';

  constructor(
    private authService: AuthService,
    private screenTimeTracker: ScreenTimeTrackerService,
    private languageService: LanguageService,
    private courseTheme: CourseThemeService,
    private router: Router
  ) { }

  ngOnInit() {
    // Reaplica el tema del curso persistido (sobrevive reloads); default si no hay.
    this.courseTheme.restore();

    // If the user is already authenticated (page refresh), start tracking
    if (this.authService.isAuthenticated()) {
      this.screenTimeTracker.start();
    }

    // El navegador recuerda y restaura el scroll por entrada del history
    // (scrollRestoration 'auto' por default) — con HashLocationStrategy esto
    // puede pisar nuestro reset manual. Lo desactivamos para controlarlo
    // siempre nosotros.
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }

    // Con HashLocationStrategy, `scrollPositionRestoration` del Router no
    // funciona de forma confiable (limitación conocida de Angular con hash
    // routing) — se resetea el scroll manualmente en cada navegación. El
    // doble rAF espera a que el layout de la nueva ruta ya esté pintado.
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => {
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            window.scrollTo({ top: 0, left: 0 });
          });
        });
      });
  }
}
